"use strict";

import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

// import { layout } from "./layout.module";
import { auth } from "./auth.module";
import { inventory } from "./inventory.module"
import { cm } from "./cm.module"
import { purchase } from "./pm.module"
import { ivTransaction } from "./ivTransaction"
import { cmPickingList } from './cmPickingList'
import { prdManufactureOrder } from './prd.manufacture.module'
import { prdOrder } from './prd.order.module'
import { prdLabeling } from './prd.labeling.module'
import { prdProduct } from './prd.product.module'


Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    // layout,
    auth,
    inventory,
    ivTransaction,
    cm,
    cmPickingList,
    purchase,
    prdManufactureOrder,
    prdOrder,
    prdLabeling,
    prdProduct
  },
  plugins: [createPersistedState()]
});



// WEBPACK FOOTER //
// ./src/store/index.js